import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as firebase from "firebase/app";
import { environment } from "src/environments/environment";
import jwt_decode from "jwt-decode";
import { NgxPermissionsService } from "ngx-permissions";
import { AngularFireAuth } from "@angular/fire/auth";
import { Observable, of } from "rxjs";
import { finalize, map } from "rxjs/operators";
import { Router } from "@angular/router";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  accInfo = JSON.parse(localStorage.getItem("currentUser"));
  private readonly loginStartedAtKey = "loginStartedAt";
  private readonly loginMaxAgeMs = 8 * 60 * 60 * 1000;

  constructor(
    public afAuth: AngularFireAuth,
    public http: HttpClient,
    private permissionsService: NgxPermissionsService,
    private router: Router
  ) { }

  markLoginSession() {
    localStorage.setItem(this.loginStartedAtKey, Date.now().toString());
  }

  clearLoginSession() {
    localStorage.removeItem(this.loginStartedAtKey);
  }

  isLoginSessionExpired(): boolean {
    const raw = localStorage.getItem(this.loginStartedAtKey);

    if (!raw) {
      return false;
    }

    const startedAt = Number(raw);

    if (!Number.isFinite(startedAt)) {
      return true;
    }

    return Date.now() - startedAt > this.loginMaxAgeMs;
  }

  getTokenExpirationDate(token: string): Date {
    let decoded: any = jwt_decode(token);

    if (decoded.exp === undefined) return null;

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) token = localStorage.getItem("token");

    if (!token) return true;

    const date = this.getTokenExpirationDate(token);

    if (date === undefined || date == null) return true;

    return date.valueOf() < new Date().valueOf();
  }
  doAnonymousLogin() {
    return this.afAuth.auth.signInAnonymously();
  }
  // menuPermission(menuNo?){
  //   var token = localStorage.getItem('token');
  //   var gPermission = jwt_decode(token);
  //   return (gPermission['auth'].menuPermission)
  // }

  // menuPermission(menuNo?) {
  //   this.accInfo = JSON.parse(localStorage.getItem("currentUser"));
  //   console.log("auth", this.accInfo);
  //   var p = [];
  //   if (this.accInfo) {
  //     p = [this.accInfo.Role];
  //   }

  //   if (!this.isTokenExpired()) {
  //     // var token = localStorage.getItem('token');
  //     // if (token != "") {
  //     var permission = JSON.parse(localStorage.getItem(environment.permission));
  //     // console.log('permission', permission);
  //     permission.forEach((element) => {
  //       element.Role = JSON.parse(element.Role);
  //       if (menuNo && element.MenuID === menuNo) {
  //         for (let key in element.Role) {
  //           if (element.Role[key]) {
  //             p.push(key);
  //           }
  //         }
  //       }
  //       p.push(element.MenuID);
  //     });

  //     // p.push('test');

  //     this.permissionsService.loadPermissions(p);
  //     // console.log('p', p);
  //     return p;
  //     // }
  //   }
  // }



  menuPermission(menuNo?) {
    this.accInfo = JSON.parse(localStorage.getItem("currentUser"));
    console.log("auth", this.accInfo);
    let p: any[] = [];

    // ✅ ถ้ามีข้อมูลผู้ใช้ ให้ดึง Role มาด้วย
    if (this.accInfo) {
      p = [this.accInfo.Role];
    }

    // ✅ เช็ค token หมดอายุหรือยัง
    if (!this.isTokenExpired()) {
      // ดึงข้อมูล permission จาก localStorage
      let permission = null;
      try {
        permission = JSON.parse(localStorage.getItem(environment.permission));
      } catch (e) {
        console.warn('⚠️ permission JSON parse error:', e);
      }

      // ✅ ถ้าไม่มี permission หรือไม่ใช่ array ให้ตั้งเป็น []
      if (!Array.isArray(permission)) {
        console.warn('⚠️ ไม่มีข้อมูล permission หรือไม่ใช่ array');
        permission = [];
      }

      // ✅ loop permission ได้อย่างปลอดภัย
      permission.forEach((element: any) => {
        try {
          element.Role = JSON.parse(element.Role);
        } catch (e) {
          console.warn('⚠️ JSON.parse(Role) error:', e);
          element.Role = {};
        }

        if (menuNo && element.MenuID === menuNo) {
          for (let key in element.Role) {
            if (element.Role[key]) {
              p.push(key);
            }
          }
        }

        p.push(element.MenuID);
      });

      // โหลด permission เข้า service
      this.permissionsService.loadPermissions(p);
      return p;
    }

    // ถ้า token หมดอายุ ให้ return array ว่างๆ ไป
    return [];
  }









  doFacebookLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.FacebookAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  doGitHubLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GithubAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  doTwitterLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.TwitterAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("profile");
      provider.addScope("email");
      this.afAuth.auth.signInWithPopup(provider).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(value.email, value.password)
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  // doLogin(value) {
  //   return new Promise<any>((resolve, reject) => {
  //     firebase.auth().signInWithEmailAndPassword(value.email, value.password)
  //     .then(res => {
  //       resolve(res);
  //     }, err => reject(err));
  //   });
  // }
  doLogin(value) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/Auth`, value)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }
  doLine(value) {
    let acc = { LineID: value };
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/LineAuth`, acc)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  CheckLineID(value) {
    let acc = { LineID: value };
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/LineAuth`, acc)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  doLoginstd(value) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrlGo}/student-api/Auth`, value)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }
  doLoginParent(value) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/parent-api/Auth`, value)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  LogoutLineParent(data) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/parent-api/LogoutLine`, data)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  ///line-parent

  doLineParent(value) {
    let acc = { LineID: value };
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/parent-api/LineAuthParent`, acc)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  // doLogout() {
  //   return new Promise<void>((resolve, reject) => {
  //     if (localStorage.getItem("currentUser")) {
  //       let guard = JSON.parse(localStorage.getItem("currentUser"));

  //       localStorage.removeItem("currentUser");
  //       localStorage.removeItem("token");
  //       if (guard.guard == "SYS") {
  //         // window.location.href = "/system"; //อันเก่า ภูมิปิด
    
  //         window.location.href = "/webboard/";

  //       } else {
  //         // window.location.href = "/system"; //อันเก่า ภูมิปิด
  //         window.location.href = "/webboard/";

  //       }

  //       this.afAuth.auth.signOut();
  //     } else {
  //       localStorage.removeItem("currentUser");
  //       reject();
  //     }
  //   });
  // }




doLogout() {
  return new Promise<void>((resolve, reject) => {
    if (localStorage.getItem("currentUser")) {

      let guard = JSON.parse(localStorage.getItem("currentUser"));

      // ⭐ เก็บ path ปัจจุบัน
      const currentPath = window.location.pathname;

      // ล้างข้อมูล
      localStorage.removeItem("currentUser");
      localStorage.removeItem("token");
      this.clearLoginSession();

      // ===== เงื่อนไข redirect =====
      // ✅ ถ้าอยู่ที่ http://localhost:4200/
      if (currentPath === '/' || currentPath === '') {

        window.location.href = '/system';

      } else {

        // ❗ พฤติกรรมเดิมของคุณ
        window.location.href = '/webboard/';
      }

      // logout firebase
      this.afAuth.auth.signOut();

      resolve();

    } else {
      localStorage.removeItem("currentUser");
      this.clearLoginSession();
      reject();
    }
  });
}





  doLogoutVote() {
    return new Promise<void>((resolve, reject) => {
      if (localStorage.getItem("currentUser")) {
        let guard = JSON.parse(localStorage.getItem("currentUser"));

        localStorage.removeItem("currentUser");
        localStorage.removeItem("token");
        this.clearLoginSession();
        this.clearLoginSession();
        if (guard.guard == "SYS") {
          window.location.href = "/vote";
          // window.location.href = '/dormitory/vote';
        } else {
          window.location.href = "/vote";
        }

        this.afAuth.auth.signOut();
      } else {
        localStorage.removeItem("currentUser");
        this.clearLoginSession();
        reject();
      }
    });
  }

  doLogoutstd() {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("currentUser")) {
        localStorage.removeItem("currentUser");
        localStorage.removeItem("token");
        this.clearLoginSession();
        window.location.href = "/";
        this.afAuth.auth.signOut();
      } else {
        localStorage.removeItem("currentUser");
        this.clearLoginSession();
        reject();
      }
    });
  }

  doSignOut() {
    return new Promise<void>((resolve, reject) => {
      // if (localStorage.getItem('currentUser')) {
      localStorage.removeItem("currentUser");
      localStorage.removeItem("token");
      this.clearLoginSession();
      // this.afAuth.auth.signOut();
      resolve();
      // } else {
      //   localStorage.removeItem('currentUser');
      //   reject();
      // }
    });
  }

  LogoutLine(data) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/LogoutLine`, data)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  doLoginSecurity(value) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/AuthSecurity`, value)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  doLogoutSecurity() {
    return new Promise<void>((resolve, reject) => {
      if (localStorage.getItem("currentUser")) {
        let guard = JSON.parse(localStorage.getItem("currentUser"));

        localStorage.removeItem("currentUser");
        localStorage.removeItem("token");
        if (guard.guard == "SECURITY") {
          window.location.href = "/security";
          // window.location.href = '/dormitory/security';
        } else {
          window.location.href = "/security";
        }

        this.afAuth.auth.signOut();
      } else {
        localStorage.removeItem("currentUser");
        this.clearLoginSession();
        reject();
      }
    });
  }

  doLoginPnc(value) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/AuthPnc`, value)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  doLogoutPnc() {
    return new Promise<void>((resolve, reject) => {
      if (localStorage.getItem("currentUser")) {
        let guard = JSON.parse(localStorage.getItem("currentUser"));

        localStorage.removeItem("currentUser");
        localStorage.removeItem("token");
        this.clearLoginSession();
        if (guard.guard == "PNC") {
          window.location.href = "/pnc/booth-visit";
        } else {
          window.location.href = "/pnc/booth-visit";
        }

        this.afAuth.auth.signOut();
      } else {
        localStorage.removeItem("currentUser");
        this.clearLoginSession();
        reject();
      }
    });
  }

  ///////
  getUserByToken(): Observable<any> {
    const auth = localStorage.getItem("token");
    console.log(auth);
    if (!auth || !this.accInfo.UserNo) {
      return of(undefined);
    }
    if (!auth || this.accInfo.guard != "PNC") {
      return this.http
        .get<any>(`${environment.apiUrl}/me?UserNo=${this.accInfo.UserNo}`)
        .pipe(
          map((user: any) => {
            localStorage.setItem("currentUser", JSON.stringify(user));
            return user;
          }),
          finalize(() => console.log("finalize"))
        );
    }
    if (!auth || this.accInfo.guard == "PNC") {
      return this.http
        .get<any>(`${environment.apiUrl}/pnc?UserNo=${this.accInfo.UserNo}`)
        .pipe(
          map((user: any) => {
            localStorage.setItem("currentUser", JSON.stringify(user));
            return user;
          }),
          finalize(() => console.log("finalize"))
        );
    }
  }



  registerRotaryBlog(data) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/register`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  RotaryBlogsendOtp(data) {
     return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/auth/send-otp`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  changePassword(data: { oldPassword: string; newPassword: string }) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(`${environment.apiUrl}/changePassword`, data)
        .subscribe(resolve, reject);
    });
  }




}
